<template>
  <textarea
    :value="modelValue"
    :rows
    :placeholder
    :disabled
    :readonly="readOnly"
    class="text-gray-90 disabled:bg-gray-20 disabled:border-gray-20 disabled:placeholder-gray-60 focus:shadow-input-focus focus:border-active-primary min-w-[216px] rounded border p-2 text-sm placeholder-gray-50 focus:outline-0"
    :class="[
      error ? 'bg-red-10 border-red-40 focus:shadow-input-error focus:border-red-50' : 'bg-gray-10 border-gray-30',
    ]"
    @input="handleInput"
  />
</template>

<script lang="ts" setup>
defineProps<{
  modelValue?: string
  placeholder?: string
  rows?: string
  disabled?: boolean
  readOnly?: boolean
  error?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const handleInput = (event: Event) => {
  if (event.target instanceof HTMLTextAreaElement) emit('update:modelValue', event.target.value)
}
</script>
